<template>
  <div class="container dataset-facets">
    <div class="row mr-md-0" :class="isAdvancedSearch === false ? 'mx-3' : false">
      <div
        class="col"
        :class="isAdvancedSearch === true ? 'advanced-column' : false"
      > 
        <!-- Hide mapping/catalog/settings while in Most Liked -->
        <datasets-map-facet
          v-if="!isMostLikedMode"
          :showCatalogDetails="showCatalogDetails"
        />
        <catalog-details-facet
          class="catalog-details"
          :catalog="catalog"
          :catalogLanguageIds="catalogLanguageIds"
        />
        <span
          v-if="!isMostLikedMode && showFacetsTitle"
          class="row h5 font-weight-bold mt-4 mb-3"
        >
          {{ $t("message.datasetFacets.filterBy") || "Filter by" }}
        </span>
        <settings-facet v-if="!isMostLikedMode" class="row facet-field mb-3" />
        <!-- The rest of the facets (hidden when in Most Liked mode) -->
        <div
          v-for="(field, index) in facetsBeforeHvd"
          :key="`facet-before@${field.id}`"
          class="row facet-field mb-3"
          :class="isAdvancedSearch === true ? 'facet-field-advanced' : false"
          v-show="!isMostLikedMode"
        >
          <!-- Radios -->
          <radio-facet
            v-if="field.id === 'dataServices'"
            :title="dataServices.title"
            :toolTipTitle="dataServices.toolTipTitle"
            :optionIds="['true', 'false']"
            :optionLabels="[dataServices.yes, dataServices.no]"
            :initialOption="getDataServices"
            :change="changeDataServices"
          />
          <radio-facet
            v-else-if="field.id === 'superCatalog'"
            :title="erpd.title"
            :toolTipTitle="erpd.toolTipTitle"
            :optionIds="['true', 'false']"
            :optionLabels="[erpd.yes, erpd.no]"
            :initialOption="isErdp"
            :change="changeErpd"
          />
          <radio-facet
            v-else-if="field.id === 'geospatial' || field.id === 'source_type'"
            :title="geospatial.title"
            :toolTipTitle="geospatial.toolTipTitle"
            :optionIds="['true', 'false']"
            :optionLabels="[geospatial.yes, geospatial.no]"
            :initialOption="isGeospatial"
            :change="changeGeospatial"
          />

          <!-- Select facets -->
          <select-facet
            v-else
            :fieldId="field.id"
            :header="facetTitle(field.id)"
            :items="getFacetItems(field)"
            :toolTipTitle="tooltip(field.id)"
            :getFacetTranslationWrapper="getFacetTranslationWrapper"
            :facetIsSelected="facetIsSelected"
            :facetClicked="facetClicked"
            :multiSelect="isMultiSelect(field.id)"
            :treeSelect="isTreeSelect(field.id)"
            class="col pr-0"
          />
        </div>

        <div
          v-if="hvdIndex > -1"
          class="row facet-field mb-3"
          v-show="!isMostLikedMode"
          :class="isAdvancedSearch === true ? 'facet-field-advanced' : false"
        >
          <radio-facet
            :toolTipTitle="hvd.toolTipTitle"
            :title="hvd.title"
            :optionIds="['true', 'false']"
            :optionLabels="[hvd.yes, hvd.no]"
            :initialOption="isHVD"
            :change="changeHVD"
          />
        </div>
        <div
          v-if="showGeospatialStandalone"
          class="row facet-field mb-3"
          v-show="!isMostLikedMode"
          :class="isAdvancedSearch === true ? 'facet-field-advanced' : false"
        >
          <radio-facet
            :toolTipTitle="geospatial.toolTipTitle"
            :title="geospatial.title"
            :optionIds="['true', 'false']"
            :optionLabels="[geospatial.yes, geospatial.no]"
            :initialOption="isGeospatial"
            :change="changeGeospatial"
          />
        </div>

        <div
          v-for="(field, index) in facetsAfterHvd"
          :key="`facet-after@${field.id}`"
          class="row facet-field mb-3"
          v-show="!isMostLikedMode"
          :class="isAdvancedSearch === true ? 'facet-field-advanced' : false"
        >
          <!-- radios -->
          <radio-facet
            v-if="field.id === 'dataServices'"
            :title="dataServices.title"
            :toolTipTitle="dataServices.toolTipTitle"
            :optionIds="['true', 'false']"
            :optionLabels="[dataServices.yes, dataServices.no]"
            :initialOption="getDataServices"
            :change="changeDataServices"
          />
          <radio-facet
            v-else-if="field.id === 'superCatalog'"
            :title="erpd.title"
            :toolTipTitle="erpd.toolTipTitle"
            :optionIds="['true', 'false']"
            :optionLabels="[erpd.yes, erpd.no]"
            :initialOption="isErdp"
            :change="changeErpd"
          />
          <radio-facet
            v-else-if="field.id === 'geospatial' || field.id === 'source_type'"
            :title="geospatial.title"
            :toolTipTitle="geospatial.toolTipTitle"
            :optionIds="['true', 'false']"
            :optionLabels="[geospatial.yes, geospatial.no]"
            :initialOption="isGeospatial"
            :change="changeGeospatial"
          />
          <!-- selects -->
          <select-facet
            v-else
            :fieldId="field.id"
            :header="facetTitle(field.id)"
            :items="getFacetItems(field)"
            :toolTipTitle="tooltip(field.id)"
            :getFacetTranslationWrapper="getFacetTranslationWrapper"
            :facetIsSelected="facetIsSelected"
            :facetClicked="facetClicked"
            :multiSelect="isMultiSelect(field.id)"
            :treeSelect="isTreeSelect(field.id)"
            class="col pr-0"
          />
        </div>
        <div
          class="row facet-field mb-3"
          v-if="isMoreFiltersOpen && useCommentsAndLikes"
          :class="isAdvancedSearch === true ? 'facet-field-advanced' : false"
        >
          <radio-facet
            :key="`most-liked-${isMostLiked}`"
            :title="mostLikedDiv.title"
            :toolTipTitle="mostLikedDiv.toolTipTitle"
            :optionIds="['true', 'false']"
            :optionLabels="[mostLikedDiv.yes, mostLikedDiv.no]"
            :initialOption="isMostLiked"
            :change="mostLiked"
          />
        </div>

        <!-- Hide Show more / Clear buttons in Most Liked -->
        <div>
          <pv-show-more
            v-if="showMoreFacetsShown && !isMostLikedMode && !isAdvancedSearch"
            :label="
              cutoff >= 0
                ? $t('message.datasetFacets.moreFilters')
                : $t('message.datasetFacets.lessFilters')
            "
            :upArrow="cutoff === -1"
            :action="toggleCutoff"
            class="p-0 row facets-show-more"
          />
        </div>

        <pv-button
          v-if="!isMostLikedMode && showClearButton && showClearButtonAdvanced"
          label="Clear filters"
          class="row mt-5 facets-clear"
          :action="clearFacets"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { isObject, isArray, isString, has, isNil, isNumber } from "lodash-es";

import {
  getFacetTranslation,
  getTranslationFor,
  DatasetsMapFacet,
  CatalogDetailsFacet,
  SettingsFacet,
} from "@piveau/piveau-hub-ui-modules";

const LEGACY_DATA_SCOPE_FACET_ID = "dataScope";
const CORPORATE_BODY_SCOPE_FACET_ID = "corporate-body-classification";
const CORPORATE_BODY_NATIONAL_ITEM_ID = "_NATIONAL";

const normalizeCorporateBodyItemId = (id) =>
  id === "__NATIONAL" ? CORPORATE_BODY_NATIONAL_ITEM_ID : id;

const STORAGE_KEYS = {
  FACETS_OPEN: "facetsCutoffOpen", // "true" | "false"
  // MOST_LIKED_MODE: 'mostLikedMode',    // "true" | "false"
};

export default {
  name: "datasetsFacets",
  dependencies: ["catalogService"],
  components: {
    SettingsFacet,
    CatalogDetailsFacet,
    DatasetsMapFacet,
  },
  props: {
    dataScope: {
      type: String,
      default: null,
    },
    availableFacets: {
      type: Array,
      default: null,
    },
    showClearButtonAdvanced: {
      type: Boolean,
      default: true,
    },
    /**
     * @description Sets the catalog filter to a fixed catalog id. Disables the catalog facet and hides the facet in the selected facets overview.
     * @dev Use this prop if you want to use this component in a catalog page context where the catalog is already known (e.g., provider's page).
     */
    fixedCatalogFilter: {
      type: String,
      default: "",
    },
  },
  metaInfo() {
    const catalogTitle =
      this.getTranslationFor(
        this.catalog.title,
        this.$route.query.locale,
        this.catalogLanguageIds
      ) || this.catalog.id;
    const catalogDescription =
      this.getTranslationFor(
        this.catalog.description,
        this.$route.query.locale,
        this.catalogLanguageIds
      ) || this.catalog.id;
    const title = this.currentSearchQuery
      ? `${this.currentSearchQuery}${
          this.showCatalogDetails ? ` - ${catalogTitle}` : ""
        }`
      : `${
          this.showCatalogDetails
            ? catalogTitle
            : this.$t("message.header.navigation.data.datasets")
        }`;
    return {
      title,
      meta: [
        {
          name: "description",
          vmid: "description",
          content: this.showCatalogDetails
            ? catalogDescription
            : `${this.$t("message.datasets.meta.description")}`,
        },
        {
          name: "keywords",
          vmid: "keywords",
          content: this.showCatalogDetails
            ? `${this.$env.metadata.keywords} ${this.$t(
                "message.datasets.meta.description"
              )}`
            : `${this.$env.metadata.keywords} ${this.$t(
                "message.datasets.meta.description"
              )}`,
        },
      ],
    };
  },
  data() {
    return {
      cutoff: this.$env.content.datasets.facets.cutoff,
      showClearButton: this.$env.content.datasets.facets.showClearButton,
      showFacetsTitle: this.$env.content.datasets.facets.showFacetsTitle,
      defaultFacetOrder: this.$env.content.datasets.facets.defaultFacetOrder,
      useCommentsAndLikes: this.$env.content.datasetDetails.showRatingService,
      useScoringFacets:
        this.$env.content.datasets.facets.scoringFacets.useScoringFacets,
      useDataScopeFacets: isNil(this.$route.params.ctlg_id),
      showCatalogDetails: false,
      catalog: {},
      MIN_FACET_LIMIT: this.$env.content.datasets.facets.MIN_FACET_LIMIT,
      MAX_FACET_LIMIT: this.$env.content.datasets.facets.MAX_FACET_LIMIT,
      FACET_OPERATORS: this.$env.content.datasets.facets.FACET_OPERATORS,
      FACET_GROUP_OPERATORS:
        this.$env.content.datasets.facets.FACET_GROUP_OPERATORS,
      originalHvdCategory: null,
    };
  },
  computed: {
    ...mapGetters("catalogDetails", ["getCatalog"]),
    ...mapGetters("datasets", [
      "getAllAvailableFacets",
      "getDatasetsCount",
      "getFacets",
      "getFacetOperator",
      "getFacetGroupOperator",
      "getDataServices",
      "getLimit",
      "getMinScoring",
      "getMaxScoring",
      "getPage",
      "getDatasetGeoBounds",
      "getScoringFacets",
    ]),
    isAdvancedSearch() {
      // return (
      //   this.$route.path === "/advanced-search" ||
      //   this.$route.name === "AdvancedSearch"
      // );
      console.log(this.isMoreFiltersOpen);

      return window.location.pathname.includes("advanced");
    },
    dataServices() {
      return {
        yes: this.i18n.global.t("message.metadata.yes"),
        no: this.i18n.global.t("message.metadata.no"),
        property: this.i18n.global.t(
          "message.datasetFacets.facets.dataServices.dataServicesOnly"
        ),
        title: this.i18n.global.t("message.metadata.dataServices"),
        toolTipTitle: this.i18n.global.t("message.helpIcon.dataServices"),
      };
    },
    erpd() {
      return {
        yes: this.i18n.global.t("message.metadata.yes"),
        no: this.i18n.global.t("message.metadata.no"),
        property: this.i18n.global.t("message.datasetFacets.facets.erpdOnly"),
        title: this.i18n.global.t("message.datasetFacets.facets.erpd"),
      };
    },
    hvd() {
      return {
        yes: this.i18n.global.t("message.metadata.yes"),
        no: this.i18n.global.t("message.metadata.no"),
        property: this.i18n.global.t("message.datasetFacets.facets.hvdsOnly"),
        title: this.i18n.global.t("message.datasetFacets.facets.hvdTitle"),
        toolTipTitle: this.i18n.global.t("message.helpIcon.hvdToolTipTile"),
      };
    },
    geospatial() {
      return {
        yes: this.i18n.global.t("message.metadata.yes"),
        no: this.i18n.global.t("message.metadata.no"),
        title: this.i18n.global.t("message.datasetFacets.facets.geospatial"),
        toolTipTitle: this.i18n.global.t("message.helpIcon.geospatial"),
      };
    },
    mostLikedDiv() {
      return {
        yes: this.i18n.global.t("message.metadata.yes"),
        no: this.i18n.global.t("message.metadata.no"),
        title: this.i18n.global.t("message.datasetFacets.mostLiked"),
        toolTipTitle:
          this.i18n.global.t("message.datasetFacets.mostLikedTooltip") || "",
      };
    },
    resolvedAvailableFacets() {
      // Use store facets by default; prop is currently unused
      return this.normalizeFacets(this.availableFacets || this.getAllAvailableFacets);
    },
    datasetBoundsWatcher() {
      return this.getDatasetGeoBounds;
    },
    facetGroupOperatorWatcher() {
      return this.getFacetGroupOperator;
    },
    useCatalogFacets() {
      return !this.showCatalogDetails;
    },
    currentSearchQuery() {
      return this.$route.query.query;
    },
    showMoreFacetsShown() {
      return (
        this.$env.content.datasets.facets.cutoff > 0 &&
        this.$env.content.datasets.facets.cutoff <
          this.getAllVisibleFacets.length
      );
    },
    getAllVisibleFacets() {
      // NOTE: no virtual "mostLiked" facet here anymore
      return this.resolvedAvailableFacets.filter(
        (facet) => {
          const selected = this.$route.query?.[facet.id];
          const hasSelection = Array.isArray(selected)
            ? selected.length > 0
            : !!selected;
          return facet.items.length > 0 || hasSelection;
        }
      );
    },
    getSortedFacets() {
      // Original logic (without injecting mostLiked)
      let availableFacets = this.resolvedAvailableFacets;
      const activeFacets = [];
      const inactiveFacets = [];
      const activeFields = Object.keys(this.getFacets).filter(
        (key) => this.getFacets[key].length > 0
      );
      const isAlreadyAdded = (id) =>
        activeFacets.some((f) => f.id === id) ||
        inactiveFacets.some((f) => f.id === id);
      const isGeospatialAlias = (orderedFacetId, availableFacetId) =>
        (orderedFacetId === "geospatial" && availableFacetId === "source_type") ||
        (orderedFacetId === "source_type" && availableFacetId === "geospatial");

      this.defaultFacetOrder.forEach((facet) => {
        availableFacets.forEach((field) => {
          if (
            (facet === field.id || isGeospatialAlias(facet, field.id)) &&
            field.items.length > 0 &&
            !isAlreadyAdded(field.id)
          ) {
            if (activeFields.includes(field.id)) activeFacets.push(field);
            else inactiveFacets.push(field);
          }
        });
      });


      const sortedFacets = activeFacets.concat(inactiveFacets);
      if (this.cutoff > 0) {
        if (this.cutoff < activeFacets.length)
          this.cutoff = activeFacets.length;
        return sortedFacets.slice(0, this.cutoff);
      }
      return sortedFacets;
    },
    // Returns the current catalog's available language ids
    catalogLanguageIds() {
      const languages = this.getCatalog && this.getCatalog.languages;
      if (!isArray(languages)) return [];
      return languages.map((lang) => lang && lang.id).filter((lang) => lang);
    },
    isErdp() {
      if (this.$route.path === "/catalogues/erpd") {
        return "true";
      } else {
        const superCatalogs = this.getFacets.superCatalog;
        return superCatalogs && superCatalogs[0] === "erpd" ? "true" : "false";
      }
    },
    isHVD() {
      return this.$route.query.is_hvd === "true" ? "true" : "false";
    },
    isGeospatial() {
      return this.$route.query.source_type === "geospatial" ? "true" : "false";
    },
    isMostLiked() {
      return this.$route.query.mostLiked === "true" ? "true" : "false";
    },
    isMostLikedMode() {
      return this.$route.query.mostLiked === "true";
    },
    hvdIndex() {
      return this.getSortedFacets.findIndex((f) => f.id === "is_hvd");
    },
    geospatialIndex() {
      return this.getSortedFacets.findIndex(
        (f) => f.id === "geospatial" || f.id === "source_type"
      );
    },
    showGeospatialStandalone() {
      const orderedGeospatial =
        this.defaultFacetOrder.includes("geospatial") ||
        this.defaultFacetOrder.includes("source_type");
      return orderedGeospatial && this.geospatialIndex === -1;
    },
    facetsBeforeHvd() {
      return this.hvdIndex > -1
        ? this.getSortedFacets.slice(0, this.hvdIndex)
        : this.getSortedFacets;
    },
    facetsAfterHvd() {
      return this.hvdIndex > -1
        ? this.getSortedFacets.slice(this.hvdIndex + 1)
        : [];
    },
    isMoreFiltersOpen() {
      return this.cutoff === -1;
    },
    activeDataScopeFacetId() {
      return this.$env?.content?.datasets?.facets?.dataScopeFacetId || LEGACY_DATA_SCOPE_FACET_ID;
    },
  },
  methods: {
    isObject,
    isArray,
    isString,
    has,
    isNil,
    isNumber,
    getTranslationFor,
    getFacetTranslation,
    ...mapActions("catalogDetails", ["loadCatalog"]),
    ...mapActions("datasets", [
      "addFacet",
      "removeFacet",
      "setFacetGroupOperator",
      "setDataServices",
      "setSuperCatalogue_DEPRECATED",
      "setPage",
      "setPageCount",
      "setMinScoring",
      "setMaxScoring",
    ]),
    facetTitle(fieldId) {
      if (this.isDataScopeFacetId(fieldId)) {
        return this.i18n.global.t("message.datasetFacets.facets.datascope");
      }
      return fieldId === "scoring"
        ? this.i18n.global.t("message.header.navigation.data.metadataquality")
        : this.i18n.global.t(
            `message.datasetFacets.facets.${fieldId.toLowerCase()}`
          );
    },
    tooltip(fieldId) {
      return this.isDataScopeFacetId(fieldId)
        ? this.i18n.global.t("message.helpIcon.dataScope")
        : this.i18n.global.t(`message.helpIcon.${fieldId.toLowerCase()}`);
    },
    getFacetTranslationWrapper(fieldId, facetId, userLocale, fallback) {
      return fieldId === "scoring"
        ? this.$t(`message.datasetFacets.facets.scoring.${facetId}`)
        : this.getFacetTranslation(fieldId, facetId, userLocale, fallback);
    },
    sortByCount(items, fieldId) {
      if (fieldId === "scoring" || this.isDataScopeFacetId(fieldId)) return items;
      return items.slice().sort((a, b) => {
        const n = b.count - a.count;
        if (n !== 0) return n;
        if (a.name < b.name) return -1;
        return 1;
      });
    },
    getFacetItems(field) {
      return this.sortByCount(field.items, field.id);
    },
    setRouteQuery(query, mode) {
      if (mode === "replace") {
        return this.$router
          .replace({ query: Object.assign({}, this.$route.query, query) })
          .catch((error) => {
            console.error(error);
          });
      } else {
        return this.$router
          .push({ query: Object.assign({}, this.$route.query, query) })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    getSanitizedHvdCategoryQuery(query) {
      const nextQuery = Object.assign({}, query);
      const rawHvdCategory = nextQuery.hvdCategory;
      if (isNil(rawHvdCategory)) return nextQuery;

      const selected = Array.isArray(rawHvdCategory)
        ? rawHvdCategory
        : [rawHvdCategory];
      const hvdFacet = this.resolvedAvailableFacets.find(
        (facet) => facet.id === "hvdCategory"
      );
      const availableIds = new Set(
        (hvdFacet?.items || []).map((item) => String(item.id))
      );
      const filtered = selected.filter((id) => availableIds.has(String(id)));

      if (filtered.length > 0) nextQuery.hvdCategory = filtered;
      else delete nextQuery.hvdCategory;

      return nextQuery;
    },
    replaceRouteQueryWithSanitizedHvdCategory(query) {
      const mergedQuery = Object.assign({}, this.$route.query, query);
      const sanitizedQuery = this.getSanitizedHvdCategoryQuery(mergedQuery);
      return this.$router.replace({ query: sanitizedQuery }).catch((error) => {
        console.error(error);
      });
    },
    syncRouteHvdCategoryWithAvailableFacets() {
      if (!Object.prototype.hasOwnProperty.call(this.$route.query, "hvdCategory")) {
        return;
      }

      const currentRaw = this.$route.query.hvdCategory;
      const current = Array.isArray(currentRaw) ? currentRaw : [currentRaw];
      const sanitizedQuery = this.getSanitizedHvdCategoryQuery(this.$route.query);
      const sanitizedRaw = sanitizedQuery.hvdCategory;
      const next = isNil(sanitizedRaw)
        ? []
        : Array.isArray(sanitizedRaw)
        ? sanitizedRaw
        : [sanitizedRaw];
      const changed =
        current.length !== next.length ||
        current.some((value, index) => String(value) !== String(next[index]));

      if (changed) {
        this.$router.replace({ query: sanitizedQuery }).catch((error) => {
          console.error(error);
        });
      }
    },
    facetIsSelected(fieldId, item) {
      const facet = item.id;
      const dataScopeQueryKey = this.getDataScopeQueryKey();
      if (fieldId === "scoring") {
        const qMinScoring = parseInt(this.getMinScoring, 10);
        const minScoringIsSelected = this.$route.query[fieldId];
        if (!minScoringIsSelected || !qMinScoring) {
          return item.minScoring === 0;
        }
        return minScoringIsSelected && qMinScoring === item.minScoring;
      }
      if (!Object.prototype.hasOwnProperty.call(this.$route.query, fieldId)) {
        return false;
      }
      if (this.isDataScopeFacetId(fieldId)) return (this.$route.query[dataScopeQueryKey] ?? this.$route.query.dataScope) === facet;
      let qField = this.$route.query[fieldId];
      if (!Array.isArray(qField)) qField = [qField];
      if (fieldId === "categories") {
        // Ignore Case for categories
        facet.toUpperCase();
        qField = qField.map((f) => f.toUpperCase());
      }
      return qField.indexOf(facet) > -1;
    },
    facetClicked(field, item) {
      const facet = item.id;
      const dataScopeQueryKey = this.getDataScopeQueryKey();
      if (this.isDataScopeFacetId(field)) {
        this.dataScopeFacetClicked(facet);
      } else {
        if (field === "scoring") this.scoringFacetClicked(item);

        // Syncing dataScope with country/provenance only applies to the legacy
        // "dataScope" facet (values: eu, io, countryData). When the active
        // dataScope facet is "corporate-body-classification" (values: CB_EU,
        // CB_OTHER, _NATIONAL), it is an independent facet and must NOT be
        // overwritten when a provenance/country is selected.
        if (
          field === "country" &&
          this.activeDataScopeFacetId === LEGACY_DATA_SCOPE_FACET_ID &&
          (Object.prototype.hasOwnProperty.call(this.$route.query, dataScopeQueryKey) || Object.prototype.hasOwnProperty.call(this.$route.query, "dataScope"))
        ) {
          if (facet === "eu") {
            this.$route.query[dataScopeQueryKey] = "eu";
          } else if (facet === "io") {
            this.$route.query[dataScopeQueryKey] = "io";
          } else {
            this.$route.query[dataScopeQueryKey] = "countryData";
          }
          delete this.$route.query.dataScope;
        }
        this.toggleFacet(field, facet);
      }
    },
    dataScopeFacetClicked(dataScope) {
      const dataScopeQueryKey = this.getDataScopeQueryKey();
      // Only the legacy "dataScope" facet (eu, io, countryData) is linked to
      // country/provenance. The "corporate-body-classification" facet is
      // independent and must not clear or be cleared by country selections.
      const isLegacyDataScope = this.activeDataScopeFacetId === LEGACY_DATA_SCOPE_FACET_ID;
      if ((this.$route.query[dataScopeQueryKey] ?? this.$route.query.dataScope) === dataScope) {
        const query = Object.assign({}, this.$route.query, {
          [dataScopeQueryKey]: [],
          page: 1,
        });
        delete query.dataScope;
        if (isLegacyDataScope) delete query.country;

        if (this.originalHvdCategory) {
          query.hvdCategory = this.originalHvdCategory;
          this.originalHvdCategory = null;
          return this.$router.replace({ query }).catch((error) => {
            console.error(error);
          });
        }
        this.replaceRouteQueryWithSanitizedHvdCategory(query);
      } else {
        if (this.$route.query.hvdCategory && !this.originalHvdCategory) {
          this.originalHvdCategory = JSON.parse(
            JSON.stringify(this.$route.query.hvdCategory)
          );
        }
        const query = Object.assign({}, this.$route.query, {
          [dataScopeQueryKey]: dataScope,
          page: 1,
        });
        delete query.dataScope;
        if (isLegacyDataScope) delete query.country;
        this.replaceRouteQueryWithSanitizedHvdCategory(query);
      }
    },
    toggleFacet(field, facet) {
      const dataScopeQueryKey = this.getDataScopeQueryKey();
      if (!Object.prototype.hasOwnProperty.call(this.$route.query, [field])) {
        this.setRouteQuery({ [field]: [], page: 1 });
      }
      let facets = this.$route.query?.[field]?.slice() || [];
      if (!Array.isArray(facets)) facets = [facets];
      if (field === "categories") {
        facet.toUpperCase();
        facets = facets.map((f) => f.toUpperCase());
      }
      if (field === "scoring") {
        facets = facet === "badScoring" ? [] : [facet];
      } else {
        const index = facets.indexOf(facet);
        if (index > -1) facets.splice(index, 1);
        else facets.push(facet);
      }
      if (field === "country") {
        if (this.$route.query.hvdCategory && !this.originalHvdCategory) {
          this.originalHvdCategory = JSON.parse(
            JSON.stringify(this.$route.query.hvdCategory)
          );
        }
        const query = Object.assign({}, this.$route.query, {
          [field]: facets,
          page: 1,
        });
        if (facets.length === 0) {
          // Only clear the dataScope query key when using the legacy "dataScope"
          // facet (linked to country). For "corporate-body-classification" the
          // dataScope facet is independent and must be preserved.
          if (this.activeDataScopeFacetId === LEGACY_DATA_SCOPE_FACET_ID) {
            delete query[dataScopeQueryKey];
            delete query.dataScope;
          }
          if (this.originalHvdCategory) {
            query.hvdCategory = this.originalHvdCategory;
            this.originalHvdCategory = null;
            return this.$router.replace({ query }).catch((error) => {
              console.error(error);
            });
          }
        }
        return this.$router
          .replace({ query: this.getSanitizedHvdCategoryQuery(query) })
          .catch((error) => {
            console.error(error);
          });
      }
      return this.setRouteQuery({ [field]: facets, page: 1 });
    },
    clearFacets() {
      this.originalHvdCategory = null;
      if (
        Object.keys(this.$route.query).some(
          (key) =>
            key !== "locale" && key !== "page" && this.$route.query[key].length
        )
      ) {
        this.setMinScoring(0);
        this.setMaxScoring(undefined);
        this.$router
          .push({ query: { locale: this.$i18n.locale, page: "1" } })
          .catch((error) => {
            console.error(error);
          });
      }
      sessionStorage.clear();
    },
    scoringFacetClicked(item) {
      // Spezieller Fall: "badScoring" entfernt alle Scoring-Filter inkl. maxScoring
      if (item && item.id === "badScoring") {
        this.setMinScoring(0);
        if (typeof this.setMaxScoring === "function")
          this.setMaxScoring(undefined);
        const query = Object.assign({}, this.$route.query, { page: 1 });
        delete query.scoring;
        delete query.maxScoring;
        this.$router.replace({ query }).catch((error) => {
          console.error(error);
        });
        window.scrollTo(0, 0);
        return;
      }

      let newMinScoring = item.minScoring;
      let newMaxScoring = item.maxScoring;

      if (
        newMinScoring === this.getMinScoring &&
        newMaxScoring === this.getMaxScoring
      ) {
        newMinScoring = 0;
        newMaxScoring = undefined; // Zurücksetzen
      }

      this.setMinScoring(newMinScoring);

      // Nur setzen wenn ein Wert vorhanden ist, sonst entfernen
      if (
        newMaxScoring !== undefined &&
        typeof this.setMaxScoring === "function"
      ) {
        this.setMaxScoring(newMaxScoring);
      } else {
        this.setMaxScoring(undefined);
      }

      const query = Object.assign({}, this.$route.query, { page: 1 });
      if (newMaxScoring !== undefined) {
        query.maxScoring = String(newMaxScoring);
      } else {
        delete query.maxScoring;
      }
      this.$router.replace({ query }).catch((error) => {
        console.error(error);
      });
      window.scrollTo(0, 0);
    },
    toggleFacetGroupOperator() {
      let op = this.getFacetGroupOperator;
      op =
        op === this.FACET_GROUP_OPERATORS.and
          ? this.FACET_GROUP_OPERATORS.or
          : this.FACET_GROUP_OPERATORS.and;
      this.setFacetGroupOperator(op);
    },
    changeDataServices(dataServices) {
      this.setDataServices(dataServices);
      const query = Object.assign({}, this.$route.query, { page: 1 });

      if (dataServices === "true") {
        query.dataServices = "true";
      } else {
        // Entferne dataServices komplett wenn "false"/No gewählt wird
        delete query.dataServices;
      }

      this.$router.replace({ query });
    },
    ensureMoreFiltersOpen() {
      this.cutoff = -1;
      sessionStorage.setItem(STORAGE_KEYS.FACETS_OPEN, "true");
    },

    restoreCutoffFromStorageIfNeeded() {
      if (this.isMostLikedMode) {
        this.ensureMoreFiltersOpen();
        return;
      }
      const open = sessionStorage.getItem(STORAGE_KEYS.FACETS_OPEN);
      if (open === "true") {
        this.cutoff = -1;
      }
    },
    changeErpd(erpd) {
      if (this.$route.path === "/catalogues/erpd") {
        const query = Object.assign({}, this.$route.query, { page: 1 });
        this.$router.replace({ path: "/datasets", query });
      } else {
        const superCatalog = erpd === "true" ? "erpd" : "false";
        const query = Object.assign({}, this.$route.query, {
          superCatalog,
          page: 1,
        });
        if (superCatalog === "false") delete query.superCatalog;
        this.$router.replace({ query });
      }
    },
    changeHVD(hvd) {
      const query = Object.assign({}, this.$route.query, {
        is_hvd: hvd,
        page: 1,
      });
      if (hvd === "false") {
        delete query.is_hvd;
        delete query.hvdCategory;
      }
      this.$router.replace({ query });
    },
    changeGeospatial(geospatial) {
      const query = Object.assign({}, this.$route.query, {
        source_type: geospatial === "true" ? "geospatial" : undefined,
        page: 1,
      });
      if (geospatial === "false") delete query.source_type;
      this.$router.replace({ query });
    },
    resetPage() {
      this.setRouteQuery({ page: 1 }, "replace");
    },
    getFacetCount(field, facet) {
      if (field.id === "scoring") return "";
      return facet.count;
    },
    initShowCatalogDetails() {
      const showCatalogDetails = !isNil(this.$route.params.ctlg_id);
      if (showCatalogDetails === true) {
        this.showCatalogDetails = true;
        this.loadCatalog(this.$route.params.ctlg_id);
      } else this.showCatalogDetails = false;
    },
    initMinScoring() {
      let currentScoring = this.$route.query.scoring;
      currentScoring =
        isArray(currentScoring) && currentScoring.length > 0
          ? currentScoring[0]
          : isArray(currentScoring) && currentScoring.length === 0
          ? ""
          : currentScoring;
      if (currentScoring) {
        let scoringFacets =
          this.$env.content.datasets.facets.scoringFacets.defaultScoringFacets;
        Object.keys(scoringFacets).forEach((score) => {
          if (score === currentScoring) {
            this.setMinScoring(scoringFacets[score].minScoring);
            this.setMaxScoring(scoringFacets[score].maxScoring);
          }
        });
      } else {
        this.setMinScoring(0);
        this.setMaxScoring(undefined);
      }
    },
    isMultiSelect(fieldID) {
      return fieldID !== "scoring";
    },
    getDataScopeQueryKey() {
      return this.$env?.content?.datasets?.facets?.dataScopeFacetId || CORPORATE_BODY_SCOPE_FACET_ID;
    },
    isDataScopeFacetId(fieldId) {
      return (
        fieldId === LEGACY_DATA_SCOPE_FACET_ID ||
        fieldId === CORPORATE_BODY_SCOPE_FACET_ID ||
        this.normalizeDataScopeFacetId(fieldId) === this.activeDataScopeFacetId
      );
    },
    normalizeDataScopeFacetId(fieldId) {
      if (
        fieldId === LEGACY_DATA_SCOPE_FACET_ID ||
        fieldId === CORPORATE_BODY_SCOPE_FACET_ID
      ) {
        return this.activeDataScopeFacetId;
      }
      return fieldId;
    },
    isCorporateBodyDataScopeEnabled() {
      return this.activeDataScopeFacetId === CORPORATE_BODY_SCOPE_FACET_ID;
    },
    normalizeFacetField(field) {
      if (!field || !field.id) return field;
      const normalizedFieldId = this.normalizeDataScopeFacetId(field.id);
      const facetItems = Array.isArray(field.items) ? field.items : [];

      if (!this.isDataScopeFacetId(normalizedFieldId)) {
        return {
          ...field,
          id: normalizedFieldId,
        };
      }

      const deduped = new Map();
      facetItems.forEach((item) => {
        if (!item) return;

        const normalizedItemId = normalizeCorporateBodyItemId(item.id);

        if (!deduped.has(normalizedItemId)) {
          deduped.set(normalizedItemId, {
            ...item,
            id: normalizedItemId,
          });
        }
      });

      return {
        ...field,
        id: this.activeDataScopeFacetId,
        items: Array.from(deduped.values()),
      };
    },
    normalizeFacets(facets) {
      if (!Array.isArray(facets)) return [];
      const deduped = new Map();
      facets
        .map((facet) => this.normalizeFacetField(facet))
        .filter((facet) => facet && facet.id)
        .forEach((facet) => {
          deduped.set(facet.id, facet);
        });
      return Array.from(deduped.values());
    },
    isTreeSelect(fieldID) {
      return fieldID === "hvdCategory";
    },
    rememberMostLikedMode(isOn) {
      sessionStorage.setItem(
        STORAGE_KEYS.MOST_LIKED_MODE,
        isOn ? "true" : "false"
      );
    },
    refreshTooltips() {
      this.$nextTick(() => {
        const jq = window.$;
        if (!jq) return;
        jq(".tooltip").remove();
        jq("[data-toggle='tooltip']").tooltip("dispose");
        jq("[data-toggle='tooltip']").tooltip({ container: "body" });
      });
    },
    toggleCutoff() {
      if (this.isAdvancedSearch) {
        this.cutoff = -1;
      } else
        this.cutoff =
          this.cutoff >= 0 ? -1 : this.$env.content.datasets.facets.cutoff;
      sessionStorage.setItem(
        STORAGE_KEYS.FACETS_OPEN,
        this.cutoff === -1 ? "true" : "false"
      );
      this.refreshTooltips();
    },
    mostLiked(val) {
      const query = Object.assign({}, this.$route.query, { page: 1 });
      console.log("Toggling Most Liked to:", val);
      if (val === "true") {
        // Enter Most Liked mode via URL parameter
        query.mostLiked = "true";
        query.sort = "mostLiked";

        // Optional: Store auch aktualisieren für andere Komponenten
        this.$store.dispatch("search/setSortType", "mostLiked");
        this.$store.commit("search/SET_IS_MOST_LIKED_MODE", true);
      } else {
        // Exit Most Liked mode
        delete query.mostLiked;
        delete query.sort; // oder setze auf default sort

        // Optional: Store auch aktualisieren
        this.$store.commit("search/SET_IS_MOST_LIKED_MODE", false);
        const defaultSort = `relevance+desc, modified+desc, title.${this.$route.query.locale}+asc`;
        this.$store.dispatch("search/setSortType", defaultSort);
      }

      // URL aktualisieren
      this.$router.replace({ query }).catch((error) => {
        console.error(error);
      });
    },
  },
  mounted() {
    if (this.isAdvancedSearch) {
      this.toggleCutoff();
    }

    this.refreshTooltips();

    if (this.$route.query.hvdCategory && !this.originalHvdCategory) {
      const country = this.$route.query.country;
      const hasCountry = Array.isArray(country) ? country.length > 0 : !!country;
      if (hasCountry) {
        this.originalHvdCategory = JSON.parse(
          JSON.stringify(this.$route.query.hvdCategory)
        );
      }
    }

    this._unwatchGuard = this.$router.beforeResolve((to, from) => {
      const hadCountry = from.query.country && (Array.isArray(from.query.country) ? from.query.country.length > 0 : true);
      const hasCountry = to.query.country && (Array.isArray(to.query.country) ? to.query.country.length > 0 : true);
      if (hadCountry && !hasCountry) {
        const query = { ...to.query };
        const dataScopeQueryKey = this.getDataScopeQueryKey();
        let changed = false;
        if (query[dataScopeQueryKey]) {
          delete query[dataScopeQueryKey];
          changed = true;
        }
        if (query.dataScope) {
          delete query.dataScope;
          changed = true;
        }
        if (this.originalHvdCategory && to.query.hvdCategory) {
          query.hvdCategory = this.originalHvdCategory;
          this.originalHvdCategory = null;
          changed = true;
        }
        if (changed) {
          return { query };
        }
      }
    });
  },
  beforeDestroy() {
    if (this._unwatchGuard) {
      this._unwatchGuard();
    }
  },
  watch: {
    facetGroupOperatorWatcher: {
      handler(facetGroupOperator) {
        this.setRouteQuery({ facetGroupOperator }, "replace");
      },
    },
    "$route.params.ctlg_id"(showCatalogDetails) {
      this.showCatalogDetails = showCatalogDetails;
    },
    "$route.query.mostLiked": {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          // Store synchronisieren wenn sich URL-Parameter ändert
          if (newVal === "true") {
            this.$store.dispatch("search/setSortType", "mostLiked");
            this.$store.commit("search/SET_IS_MOST_LIKED_MODE", true);
          } else {
            this.$store.commit("search/SET_IS_MOST_LIKED_MODE", false);
            const defaultSort = `relevance+desc, modified+desc, title.${this.$route.query.locale}+asc`;
            this.$store.dispatch("search/setSortType", defaultSort);
          }
        }
      },
      immediate: true,
    },
    getDatasetGeoBounds(bounds) {
      this.bounds = bounds;
    },
    getCatalog(catalog) {
      this.catalog = catalog;
    },
    resolvedAvailableFacets: {
      handler() {
        this.syncRouteHvdCategoryWithAvailableFacets();
      },
      deep: true,
    },
  },
  created() {
    this.initShowCatalogDetails();
    this.initMinScoring();
    this.restoreCutoffFromStorageIfNeeded();
    if (this.$route.query.mostLiked === "true") {
      this.$store.dispatch("search/setSortType", "mostLiked");
      this.$store.commit("search/SET_IS_MOST_LIKED_MODE", true);
    }
    for (const i in sessionStorage) {
      if (sessionStorage.length > 0 && i === "Filter") this.toggleCutoff();
    }
  },
};
</script>

<style lang="scss" scoped>
.facet:hover {
  cursor: pointer;
}

.custom-control {
  padding-left: 1.5rem;
  margin-right: 1rem;
}

.custom-control-label {
  &::before {
    left: -1.5rem !important;
  }
  &::after {
    left: -1.5rem !important;
  }
}

.active {
  background-color: var(--primary);
  border-color: var(--primary);
}

.io {
  border: 0 !important;
  margin-bottom: 3px;
  opacity: 0.8;
}

.dropdown-menu.show {
  transform: translate3d(0px, 15px, 0px) !important;
  width: max-content;
  display: block;
}
.facet-field-advanced {
  width: 100%;
  max-width: none;
}
.advanced-column {
  display: grid;
  grid-template-columns: repeat(3, minmax(280px, 1fr));
  grid-auto-flow: row;
  column-gap: 1rem;
  row-gap: 0;
  align-items: start;
}
@media (max-width: 995px) {
  .advanced-column {
    grid-auto-flow: row;
    grid-template-rows: none;
    grid-template-columns: 1fr;
    row-gap: 0;
  }

  .facet-field-advanced {
    max-width: 100%;
    width: 100%;
  }
}
</style>
